var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.convertVisible)?_c('div',{ref:"convertWrapperRef",class:{
    'message-convert': true,
    'reverse': _setup.props.message.flow === 'out',
    'error': _setup.hasConvertError,
  }},[_c(_setup.ConvertContent,{attrs:{"message":_setup.props.message,"contentVisible":_setup.convertVisible,"isSingleConvert":_setup.isSingleConvert,"convertWrapperRef":_setup.convertWrapperRef},on:{"toggleErrorStatus":_setup.toggleErrorStatus}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }